import { MemberRetailProgramSubscriptionModel } from "./member-retail-program-subscription-model";

export class MemberRetailSubscriptionDetail{
    isSuccess?:boolean;
    memberRetailProgramSubscriptionModel: MemberRetailProgramSubscriptionModel;
    storeId:number;
    appPlanMapperId: number;
    planCode: string;
    operatingCompanyId: number;
    isVatAvailable: boolean;
    subscriptionStatus : number;
    subscriptionId:string;
    subscriptionStartDate: string;
    subscriptionEndDate: string;
    paymentCaptured: boolean;
    tandCAccepted: boolean;
    createdDate: string;
    createdBy: number;
    updatedDate: string;
    updatedBy: string;
    rowStatus: number;
    businessEntityId?: string;
    addressDetailId?: string;
    vatId?: string;
    supplier?: string
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/member-retail-subscription-detail.ts